import { render, staticRenderFns } from "./TransTextareaInput.vue?vue&type=template&id=a4d5afc8&"
import script from "./TransTextareaInput.vue?vue&type=script&lang=js&"
export * from "./TransTextareaInput.vue?vue&type=script&lang=js&"
import style0 from "./TransTextareaInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VInput,VTab,VTabItem,VTabs,VTabsItems})
